/* ============================================================
   ATYR STUDIO — Price decimal trim
   Removes a trailing ".00" / ",00" / ".000" from displayed prices
   (whole-value zero-decimals only — never a thousands separator and
   never real decimals like ",95"). Purely cosmetic: Shopify Markets
   rounding already makes the charged value whole, so the trimmed
   display still equals what the customer is charged.
   Converted currencies (AED, EUR, …) always carry their standard
   decimals from Shopify — this cleans them up on the storefront.
   ============================================================ */
(function () {
  'use strict';

  var SEL = [
    '.money', '.price-item',
    '.pa-price__current', '.pa-price__compare', '.pa-rec-item__price', '#pa-sticky-price',
    '.atyr-cart__item-price', '.atyr-cart__item-price--old', '.atyr-cart__item-price--sale',
    '.atyr-cart__subtotal-price', '.atyr-cart__rec-price'
  ].join(',');

  /* A separator + exactly two zeros that end the number = the decimal part.
     Must be EXACTLY "00" (not 000) and not followed by another digit/separator,
     so a thousands group like "¥10,000" or "$1,000.00" is never touched
     (in "$1,000.00" only the trailing ".00" matches; the ",000" does not). */
  var RE = /[.,]00(?=\s|$|[^\d.,])/g;

  function one(el) {
    if (!el || el.children.length) return;   // only pure-text price elements — never flatten structure
    var t = el.textContent, n = t.replace(RE, '');
    if (n !== t) el.textContent = n;
  }
  function trim(root) {
    root = root || document;
    var els = root.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) one(els[i]);
    if (root.nodeType === 1 && root.matches && root.matches(SEL)) one(root);
  }

  // Public: trim a subtree synchronously — call right after inserting prices to avoid a decimals flash
  window.atyrPriceFix = trim;

  function run() { trim(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Re-trim after cart updates / any dynamically inserted prices
  document.addEventListener('cart:refresh', function () { setTimeout(run, 150); });

  var t;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { clearTimeout(t); t = setTimeout(run, 100); return; } }
  }).observe(document.body, { childList: true, subtree: true });
}());
